export const styles = {
  button: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '3px 10px',
    gap: '8px',
    background: '#F3F4F9',
    borderRadius: '8px',
    cursor: 'pointer',
  },
  buttonText: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    color: '#23252F',
  },
};
